// extracted by mini-css-extract-plugin
export default {"league":"League_league__uc57R","text":"League_text__ncAQE","iconWrapper":"League_iconWrapper__+CObD","icon":"League_icon__xDyzW","leaguePinned":"League_leaguePinned__9muh6"};